import React from "react";
var __jsx = React.createElement;
import { InputLabel } from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';
import RichTextEditor from 'components/common/RichTextEditor';
import { Container } from './RichTextInput.style';

var getInitialValue = function getInitialValue(defaultValue, valueFromContentData) {
  if (defaultValue === undefined) {
    return undefined;
  }

  return valueFromContentData;
};

var RichTextInput = function RichTextInput(_ref) {
  var name = _ref.name,
      defaultValue = _ref.defaultValue,
      label = _ref.label,
      enabledBlocks = _ref.enabledBlocks;

  var _useFormContext = useFormContext(),
      control = _useFormContext.control;

  var inputId = "form-field-".concat(name);
  return __jsx(React.Fragment, null, __jsx(InputLabel, {
    id: inputId
  }, label), __jsx(Container, null, __jsx(Controller, {
    control: control,
    name: name,
    render: function render(_ref2) {
      var _ref2$field = _ref2.field,
          onChange = _ref2$field.onChange,
          value = _ref2$field.value;
      return __jsx(RichTextEditor, {
        inputId: inputId,
        initialRawState: getInitialValue(defaultValue, value),
        onRawStateChange: onChange,
        enabledBlocks: enabledBlocks
      });
    }
  })));
};

export default RichTextInput;